import Vue from 'vue'
import VueRouter from 'vue-router'

import getSpecialRedirectCase from './get-special-case-path'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home2.vue'),
    meta: {
      title: '新注册用户免费领VIP会员'
    }
  },
  {
    path: '/activeAdr',
    name: 'ActiveAdr',
    component: () => import('../views/ActiveAdr.vue'),
    meta: {
      title: '关注公众号'
    }
  },
  {
    path: '/activeCode',
    name: 'ActiveCode',
    component: () => import('../views/ActiveCode.vue'),
    meta: {
      title: '关注公众号'
    }
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('../views/Success.vue'),
    meta: {
      title: '新注册用户免费领VIP会员'
    }
  },
  {
    path: '/notNewUser',
    name: 'NotNewUser',
    component: () => import('../views/NotNewUser.vue'),
    meta: {
      title: '新注册用户免费领VIP会员'
    }
  },
  {
    path: '/userDeal',
    name: 'UserDeal',
    component: () => import('../views/UserDeal.vue'),
    meta: {
      title: '新注册用户免费领VIP会员'
    }
  },
  {
    path: '/userPersonal',
    name: 'UserPersonal',
    component: () => import('../views/UserPersonal.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/userAggrement',
    name: 'UserAggrement',
    component: () => import('../views/UserAggrement.vue'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/collect',
    name: 'Collect',
    component: () => import('../views/RewardCollect.vue'),
    meta: {
      title: '有奖征集'
    }
  },
  {
    path: '/collectRes',
    name: 'CollectRes',
    component: () => import('../views/RewardResult.vue'),
    meta: {
      title: '征集结果'
    }
  },
  {
    path: '/normalProblem',
    name: 'NormalProblem',
    component: () => import('../views/NormalProblem.vue'),
    meta: {
      title: '常见问题'
    }
  },
  {
    path: '/normalProblemIos',
    name: 'NormalProblemIos',
    component: () => import('../views/NormalProblemIos.vue'),
    meta: {
      title: '常见问题'
    }
  },
  {
    path: '/activeRules',
    name: 'ActiveRules',
    component: () => import('../views/ActiveRules.vue'),
    meta: {
      title: '活动规则'
    }
  },
  {
    path: '/chargeStandard',
    name: 'ChargeStandard',
    component: () => import('../views/ChargeStandard.vue'),
    meta: {
      title: '收费标准'
    }
  },
  {
    path: '/shareResult',
    name: 'ShareResult',
    component: () => import('../views/ShareResult.vue'),
    meta: {
      title: '灵云听语-结果分享'
    }
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('../views/Download'),
    meta: {
      title: '下载灵云听语'
    }
  },
  {
    path: '/vip-day',
    name: 'VipDay',
    component: () => import('../views/VipDay.vue'),
    meta: {
      title: '灵云听语 会员日'
    }
  },
  {
    path: '/how-to-find-my-device',
    name: 'HowToFindMyDevice',
    component: () => import('../views/RecorderPen/HowToFindMyDevice'),
    meta: {
      title: '如何才能发现我的设备'
    }
  },
  {
    path: '/space-manage-help',
    name: 'SpaceManageHelp',
    component: () => import('../views/RecorderPen/SpaceManageHelp'),
    meta: {
      title: '空间管理帮助'
    }
  },
  {
    path: '/soundin',
    name: 'soundin',
    component: () => import('../views/Soundin'),
    meta: {
      title: '灵云JTAM_01智能录音笔说明书'
    }
  },
  {
    path: '/recorder-pen-purchase-poster',
    name: 'RecorderPenPurchasePoster',
    component: () => import('../views/RecorderPen/PurchasePoster.vue'),
    meta: {
      title: 'AI智能录音笔'
    }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../views/404.vue')
  },
  {
    path: '*',
    component: () => import('../views/404.vue'),
    beforeEnter (from, to, next) {
      const specialCasePath = getSpecialRedirectCase(from.path)
      if (specialCasePath) {
        next(specialCasePath)
      } else {
        next()
      }
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '灵云听语'
  next()
})

export default router
